import React from 'react'
import formatPrice from '../../../helper/formatPrice'

export default function PriceRenderer(props) {
  const { value } = props

  return <span>{formatPrice(value)}</span>
}
